<template>
  <div>
    <v-row align="center" justify="space-between" no-gutters>
      <span class="subtitle-2">
        Bon de commande créé le
        {{ deliverySlip.created }} par
        {{ deliverySlip.author }}
      </span>
      <v-checkbox
        v-model="deliverySlip.is_receive"
        hide-details
        label="Commande receptionnée"
      ></v-checkbox>
    </v-row>
    <v-row align="center" no-gutters v-if="deliverySlip.supplier">
      <span class="title">
        Pour
        {{
          deliverySlip.supplier ? deliverySlip.supplier.name_fournisseur : ""
        }}
      </span></v-row
    >
    <v-row
      align="center"
      no-gutters
      v-if="
        deliverySlip.supplier &&
          deliverySlip.supplier.data &&
          (deliverySlip.supplier.data.contact_phone !== '' ||
            deliverySlip.supplier.data.contact_email !== '')
      "
    >
      <v-icon
        v-if="
          deliverySlip.supplier.data.contact_phone &&
            deliverySlip.supplier.data.contact_phone !== ''
        "
        small
        class="mr-1"
        >fa-phone</v-icon
      >
      <span
        class="caption mr-1"
        v-if="
          deliverySlip.supplier.data.contact_phone &&
            deliverySlip.supplier.data.contact_phone !== ''
        "
      >
        {{ deliverySlip.supplier.data.contact_phone }}
        {{
          deliverySlip.supplier.data.contact_poste
            ? `#${deliverySlip.supplier.data.contact_poste}`
            : ""
        }}
      </span>
      <v-icon
        v-if="
          deliverySlip.supplier.data.contact_email &&
            deliverySlip.supplier.data.contact_email !== ''
        "
        small
        class="mr-1"
        >fa-at</v-icon
      >
      <span
        class="caption mr-1"
        v-if="
          deliverySlip.supplier.data.contact_email &&
            deliverySlip.supplier.data.contact_email !== ''
        "
      >
        {{ deliverySlip.supplier.data.contact_email }}
      </span></v-row
    >
    <v-row align="center" no-gutters v-else-if="deliverySlip.supplier">
      <v-icon v-if="deliverySlip.supplier.telephone" small class="mr-1"
        >fa-phone</v-icon
      >
      <span class="caption mr-1" v-if="deliverySlip.supplier.telephone">
        {{ deliverySlip.supplier.telephone }}
        {{
          deliverySlip.supplier.telephone.poste
            ? `#${deliverySlip.supplier.telephone.poste}`
            : ""
        }}
      </span>
      <v-icon v-if="deliverySlip.supplier.courriel" small class="mr-1"
        >fa-at</v-icon
      >
      <span class="caption mr-1" v-if="deliverySlip.supplier.courriel">
        {{ deliverySlip.supplier.courriel }}
      </span></v-row
    >
  </div>
</template>

<script>
export default {
  name: "DeliverySlipViewerHeader",
  props: {
    deliverySlip: {
      required: true
    }
  }
};
</script>

<style></style>
